import "@/App.css";
import Navbar from "@/components/Navbar";
import FloatingRegister from "@/components/FloatingRegister";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import ThrustAreas from "@/sections/ThrustAreas";
import WhatToExpect from "@/sections/WhatToExpect";
import AIWorkshop from "@/sections/AIWorkshop";
import StartupTrack from "@/sections/StartupTrack";
import Speakers from "@/sections/Speakers";
import ImportantDates from "@/sections/ImportantDates";
import Registration from "@/sections/Registration";
import OrganizingTeam from "@/sections/OrganizingTeam";
import Footer from "@/sections/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <ThrustAreas />
        <WhatToExpect />
        <AIWorkshop />
        <StartupTrack />
        <Speakers />
        <ImportantDates />
        <Registration />
        <OrganizingTeam />
      </main>
      <Footer />
      <FloatingRegister />
    </div>
  );
}

export default App;
